import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { AttachmentGetCollectionByLotId, AttachmentGetCollectionByLotIdResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<AttachmentGetCollectionByLotIdResponse, AttachmentGetCollectionByLotIdResponse>) => {
    return response?.data?.attachments
}
const getError = (response?: SWRResponse<AttachmentGetCollectionByLotIdResponse, AttachmentGetCollectionByLotIdResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<LotGetCollectionByLotIdResponse, LotGetCollectionByLotIdResponse>) => ({});

const useAttachmentsByLotId = (lotId: number, configuration?: SWRConfiguration<AttachmentGetCollectionByLotIdResponse, AttachmentGetCollectionByLotIdResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new AttachmentGetCollectionByLotId({
                lotId: lotId
            });
        };
    }, [lotId])

    return useGet(request, { getData, getError }, configuration);
}

export default useAttachmentsByLotId;